import { resetChatbot } from '../redux/features/Chatbot/chatbotSlice';
import { clearAllChatbotConversations } from './chatbotConversationStorage';

/**
 * Flush all locally saved chatbot conversations and reset Redux chatbot state.
 * Call this from every logout path.
 */
export const flushChatbotOnLogout = (dispatch) => {
  // Wipe encrypted blobs + guest crypto secret; reset in-memory decrypted state.
  clearAllChatbotConversations();
  if (typeof dispatch === 'function') {
    dispatch(resetChatbot());
  }
};
